import React, { useState, forwardRef, useImperativeHandle } from "react";

const DialogModal = forwardRef(({ children, title }, ref) => {
  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal: () => setIsOpen(true),
    closeModal: () => setIsOpen(false),
  }));

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">{title}</h2>
              <button
                className="text-gray-600 hover:text-gray-800 text-2xl"
                onClick={() => setIsOpen(false)}
              >
                &times;
              </button>
            </div>
            <div className="py-4">{children}</div>
          </div>
        </div>
      )}
    </>
  );
});

DialogModal.displayName = "DialogModal";
export default DialogModal;
